/* eslint-disable array-callback-return */
/*
 * 所有商品
 */
import React from "react";
import {
  message,
  Spin,
  Dropdown,
  Menu,
  Tooltip,
  Modal,
  Affix,
  Button,
  Carousel,
} from "antd";
import InfiniteScroll from "react-infinite-scroller";
import { API, history, IconFont, imgRoot } from "../../static/js/common";
import moment from "moment";
import { LoginContext } from "../../App";
import CryptoJS from 'crypto-js';

// const { Option } = Select;

// const courier_list = ["全部", "韵达", "圆通", "顺丰", "申通", "邮政", "百世"];

// const platform_list = ["全部", "淘宝/天猫", "京东", "拼多多", "其它"];

const overtimePaid_list = [
  { overtimePaid: "全部" },
  { overtimePaid: "支持" },
  { overtimePaid: "不支持" },
];

class All extends React.Component {
  static contextType = LoginContext;
  constructor(props) {
    super(props);
    this.state = {
      isShowModal: false,
      isShowBuy: "", // 购买按钮
      page: 1,
      pageSize: 20,
      sortBy: "goods_fee",
      type1: 1,
      type2: 1,
      goods_list: [],
      hasMore: true,
      loading: false,
      address: "全部",
      courier: "全部",
      platform: "",
      overtimePaid: "",
      // isAddressRotate: false,
      // isPlatformRotate: false,
      isCourierRotate: false,
      isOvertimeRotate: false,
      address_list: [],
      courier_list: [],
      platform_list: [],
      isLine: true,
      imgType: 'main',
      goodsId: '',
      shuiyin: 'https://dfcdn.waxiang.com/source/daifa/shuiyin1.png',
      isAuth: 0,
      isShowAuth: false,
      canUse: 1
    };
  }

  componentDidMount() {
    //每天只弹出一次
    let isShowModal = false;
    const todayDate = window.localStorage.getItem("LP-TODAY-ONLY");
    const todayNowDate = moment().format("YYYY-MM-DD");
    if (todayDate !== todayNowDate) {
      isShowModal = false;
      window.localStorage.setItem("LP-TODAY-ONLY", todayNowDate);
    }
    this.setState({ isShowModal });
    this.getGoodsList();
    // API.postWarehouse({}).then((res) => {
    //   if (res.status * 1 === 0) {
    //     const address_list = ["全部"];
    //     const data = res.extData || [];
    //     data.map((item) => {
    //       if (address_list.indexOf(item.address) === -1) {
    //         address_list.push(item.address);
    //       }
    //     });
    //     this.setState({ address_list });
    //   } else {
    //     message.error(res.message || "仓库列表获取失败");
    //   }
    // });
    API.postSelectOption({}).then((res) => {
      if (res.status * 1 === 0) {
        const data = res.extData || {};
        const courier_list = data.courier || [];
        const platform_list = data.platform || [];
        const address_list = data.city || [];
        this.setState({ courier_list, platform_list, address_list });
      } else {
        message.error(res.message || "数据加载错误");
      }
    });
    API.getAuthInfo({}).then((res) => {
      if (res.status * 1 === 0) {
        const data = res.extData;
        // if(data.realSms) {
        this.setState({
          isAuth: data.needRealName,
          canUse: parseInt(data.canUse)
        })
        // }
      }
    })
  }

  urlBase64Encrypt = () => {
    const _bitArray = CryptoJS.enc.Utf8.parse(this.state.shuiyin);
    return CryptoJS.enc.Base64.stringify(_bitArray)
      .replace(/\+/g, '-')
      .replace(/\//g, '_');
    //|watermark/1/blogo/2/image/${this.urlBase64Encrypt()}/gravity/southeast/dx/20/dy/20
  };

  getGoodsList = () => {
    const {
      page,
      pageSize,
      sortBy,
      type1,
      type2,
      address,
      courier,
      platform,
      overtimePaid,
    } = this.state;
    const reqData = {
      page,
      pageSize,
      sortBy,
      address,
      courier,
      platform,
      overtimePaid: -1,
    };
    reqData.sortType = sortBy === "goods_fee" ? type1 : type2;
    if (address === "全部") {
      reqData.address = "";
    }
    if (courier === "全部") {
      reqData.courier = "";
    }
    switch (overtimePaid) {
      case "全部":
        reqData.overtimePaid = -1;
        break;
      case "支持":
        reqData.overtimePaid = 1;
        break;
      case "不支持":
        reqData.overtimePaid = 0;
        break;
      default:
        break;
    }
    switch (platform) {
      case "全部":
        reqData.platform = "";
        break;
      case "淘宝/天猫":
        reqData.platform = 1;
        break;
      case "京东":
        reqData.platform = 2;
        break;
      case "拼多多":
        reqData.platform = 3;
        break;
      case "抖音":
        reqData.platform = 5;
        break;
      case "其它":
        reqData.platform = 4;
        break;
      default:
        break;
    }
    this.setState({ loading: true });
    API.postGoodsList(reqData).then((res) => {
      this.setState({ loading: false });
      if (res.status * 1 === 0) {
        let { goods_list } = this.state;
        const data = res.extData || {};
        goods_list = goods_list.concat(data.list || []);
        const collectArr = [],
          noCollectArr = [];
        goods_list.map((item) => {
          item.isCollect * 1 === 1
            ? collectArr.push(item)
            : noCollectArr.push(item);
        });
        this.setState({
          goods_list: collectArr.concat(noCollectArr),
          hasMore: goods_list.length !== data.total * 1,
        });
      } else {
        message.error(res.message || "数据加载错误");
        this.setState({ hasMore: false });
      }
    });
  };

  // 收藏列表
  getCollectList = () => {
    const { page, pageSize } = this.state;
    const reqData = {
      page,
      pageSize,
    };
    this.setState({ loading: true });
    API.postCollectList(reqData).then((res) => {
      this.setState({ loading: false });
      if (res.status * 1 === 0) {
        let { goods_list } = this.state;
        const data = res.extData || {};
        goods_list = goods_list.concat(data.list || []);
        this.setState({
          goods_list,
          hasMore: goods_list.length !== data.total * 1,
        });
      } else {
        message.error(res.message || "数据加载错误");
        this.setState({ hasMore: false });
      }
    });
  };

  changeSort = (type, str) => {
    const { loading, sortBy } = this.state;
    if (loading) return;
    const obj = { goods_list: [], page: 1 };
    if (type === "collect") {
      if (str === 0) {
        message.error("请登录", 1.2, (_) =>
          history.push("/login?tabKey=login")
        );
        return;
      }
      obj.sortBy = type;
      this.setState(obj, (_) => this.getCollectList());
    } else {
      if (sortBy === type) {
        obj[str] = 3 - this.state[str];
      } else {
        obj.sortBy = type;
        obj[str] = 1;
      }
      this.setState(obj, (_) => this.getGoodsList());
    }
  };

  /* chooseAddress = (e) => {
    this.setState({ address: e, goods_list: [], page: 1 }, (_) =>
      this.getGoodsList()
    );
  }; */

  handleSelect = (e, state) => {
    const o = {
      goods_list: [],
      page: 1,
      isCourierRotate: false,
      isPlatformRotate: false,
      isAddressRotate: false,
      isOvertimeRotate: false,
    };
    o[state] = e;
    this.setState(o, (_) => this.getGoodsList());
  };

  handleChangeItem = (key, value) => {
    const o = {
      goods_list: [],
      page: 1,
    };
    o[key] = value;
    this.setState(o, (_) => this.getGoodsList());
  };

  // 下拉加载
  handleMoreGoodList = () => {
    const { page, hasMore, loading } = this.state;
    if (loading || !hasMore) return;
    this.setState({ page: page + 1 }, (_) => this.getGoodsList());
  };

  // 立即购买
  handlePay = (item) => {
    if(!parseInt(item.stock)){
      message.warn("库存不足");
      return;
    }
    if(this.state.canUse===2) {
      return;
    }
    if(parseInt(this.state.isAuth)===1) {
      this.setState({
        isShowAuth: true
      })
      return;
    }
    if(item.status * 1 === 1){
      history.push(
        `/seller/goods/goodsinfo?${item.goodsId}`
      )
    }else{
      message.warn("商品已下架");
    }
  };

  toAuth = () => {
    window.open(`/#/seller/account/home?status=1`,'_blank')
  };

  // 收藏、取消收藏
  handleCollect = (goodsId, isCollect, isLogin, idx, e) => {
    e.stopPropagation();
    if (isLogin === 0) {
      message.error("请登录", 1.2, (_) => history.push("/login?tabKey=login"));
      return;
    }
    const reqData = { goodsId, act: isCollect === 0 ? "add" : "del" };
    API.postHandleCollect(reqData).then((res) => {
      if (res.status * 1 === 0) {
        const { goods_list } = this.state;
        const new_goods_list = JSON.parse(JSON.stringify(goods_list));
        new_goods_list[idx].isCollect = 1 - isCollect;
        this.setState({
          goods_list: new_goods_list,
        });
        message.success(
          `${isCollect === 0 ? "收藏成功" : "取消收藏成功"}`,
          1.2
        );
      } else {
        message.error(res.message || "操作失败，请稍后再试！");
      }
    });
  };

  renderMenuItem = (arr, myKey, state, str) => (
    <Menu
      selectedKeys={[myKey]}
      onClick={(e) => this.handleSelect(e.key, state)}
    >
      {arr.map((item) => (
        <Menu.Item key={item[str]}>{item[str]}</Menu.Item>
      ))}
    </Menu>
  );

  render() {
    const {
      // isShowBuy,
      sortBy,
      type1,
      type2,
      goods_list,
      loading,
      hasMore,
      address,
      address_list,
      courier,
      platform,
      // isAddressRotate,
      // isCourierRotate,
      isPlatformRotate,
      isOvertimeRotate,
      overtimePaid,
      isShowModal,
      courier_list,
      platform_list,
      isLine,
      imgType,
      goodsId,
      isShowAuth,
      canUse
    } = this.state;
    const { isLogin } = this.context;
    return (
      <div className="home">
        <Carousel autoplay>
          <div
            className="home_banner1">
            <Carousel autoplay>
              <div
                onClick={() => {
                  this.setState({ isShowModal: true })}}>
                <img src={"https://dfcdn.waxiang.com/source/daifa/banner4.png"}/>
              </div>
              {/*<div><img src={"https://dfcdn2.diantoushi.com/source/daifa/ztc.png"}/></div>*/}
            </Carousel>
          </div>
          {/* <div
            className="home_banner"
            onClick={() => {
              this.setState({ isShowModal: true });
            }}
          ></div> */}
        </Carousel>
        <Affix offsetTop={0}>
          {/* <div>
            <div className="home_box flex-start">
              <div
                className={`home_sort flex-center ${
                  sortBy === "goods_fee" ? "home_sort_active" : ""
                }`}
                onClick={(_) => this.changeSort("goods_fee", "type1")}
              >
                价格排序
                {sortBy === "goods_fee" ? (
                  <IconFont
                    type={
                      type1 === 1 ? "icon-icon-test" : "icon-icon-test-copy"
                    }
                    style={{ fontSize: 20 }}
                  />
                ) : (
                  <IconFont
                    type="icon-icon-test-copy-copy"
                    style={{ fontSize: 20 }}
                  />
                )}
              </div>
              <div
                className={`home_sort flex-center ${
                  sortBy === "weight" ? "home_sort_active" : ""
                }`}
                onClick={(_) => this.changeSort("weight", "type2")}
              >
                重量排序
                {sortBy === "weight" ? (
                  <IconFont
                    type={
                      type2 === 1 ? "icon-icon-test" : "icon-icon-test-copy"
                    }
                    style={{ fontSize: 20 }}
                  />
                ) : (
                  <IconFont
                    type="icon-icon-test-copy-copy"
                    style={{ fontSize: 20 }}
                  />
                )}
              </div>
              <div className="home_sort_other">
                <Dropdown
                  overlay={this.renderMenuItem(
                    address_list,
                    address,
                    "address",
                    "address"
                  )}
                  trigger={["click"]}
                  placement="bottomCenter"
                  onVisibleChange={(e) => this.setState({ isAddressRotate: e })}
                  disabled={sortBy === "collect"}
                >
                  <div>
                    {address ? address : "发货地"}
                    <IconFont
                      type="icon-jiantou"
                      style={{
                        fontSize: 16,
                        marginLeft: 6,
                        transition: "transform 0.3s",
                        transform: isAddressRotate ? "rotate(180deg)" : "",
                      }}
                    />
                  </div>
                </Dropdown>
              </div>
              <div className="home_sort_other">
                <Dropdown
                  overlay={this.renderMenuItem(
                    courier_list,
                    courier,
                    "courier",
                    "courier"
                  )}
                  trigger={["click"]}
                  placement="bottomCenter"
                  onVisibleChange={(e) => this.setState({ isCourierRotate: e })}
                  disabled={sortBy === "collect"}
                >
                  <div>
                    {courier ? courier : "快递"}
                    <IconFont
                      type="icon-jiantou"
                      style={{
                        fontSize: 16,
                        marginLeft: 6,
                        transition: "transform 0.3s",
                        transform: isCourierRotate ? "rotate(180deg)" : "",
                      }}
                    />
                  </div>
                </Dropdown>
              </div>
              <div className="home_sort_other">
                <Dropdown
                  overlay={this.renderMenuItem(
                    platform_list,
                    platform,
                    "platform",
                    "plat"
                  )}
                  trigger={["click"]}
                  placement="bottomCenter"
                  onVisibleChange={(e) =>
                    this.setState({ isPlatformRotate: e })
                  }
                  disabled={sortBy === "collect"}
                >
                  <div>
                    {platform ? platform : "平台"}
                    <IconFont
                      type="icon-jiantou"
                      style={{
                        fontSize: 16,
                        marginLeft: 6,
                        transition: "transform 0.3s",
                        transform: isPlatformRotate ? "rotate(180deg)" : "",
                      }}
                    />
                  </div>
                </Dropdown>
              </div>
              <div className="home_sort_other">
                <Dropdown
                  overlay={this.renderMenuItem(
                    overtimePaid_list,
                    overtimePaid,
                    "overtimePaid",
                    "overtimePaid"
                  )}
                  trigger={["click"]}
                  placement="bottomCenter"
                  onVisibleChange={(e) =>
                    this.setState({ isOvertimeRotate: e })
                  }
                  disabled={sortBy === "collect"}
                >
                  <div>
                    {overtimePaid ? overtimePaid : "超时赔付"}
                    <IconFont
                      type="icon-jiantou"
                      style={{
                        fontSize: 16,
                        marginLeft: 6,
                        transition: "transform 0.3s",
                        transform: isOvertimeRotate ? "rotate(180deg)" : "",
                      }}
                    />
                  </div>
                </Dropdown>
              </div>
              <div
                className={`home_sort flex-center ${
                  sortBy === "collect" ? "home_sort_active" : ""
                }`}
                onClick={(_) => this.changeSort("collect", isLogin * 1)}
                style={{ margin: "0 0 0 390px" }}
              >
                <IconFont
                  type="icon-caidan"
                  style={{
                    fontSize: 16,
                    marginRight: 6,
                  }}
                />
                收藏夹
              </div>
            </div>
            <div
              style={{
                width: 1200,
                height: 10,
                background: "#f5f5f5",
                margin: "0 auto",
              }}
            ></div>
          </div> */}

          {/* 新版 */}
          <div className="home_new_box">
            <div>
              <div>地区：</div>
              <div>
                {address_list.map((item, idx) => (
                  <span
                    key={idx}
                    className={`${
                      address === item.address ? "home_new_box_active" : ""
                    } home_new_box_item`}
                    onClick={() =>
                      this.handleChangeItem("address", item.address)
                    }
                  >
                    {item.address}
                  </span>
                ))}
              </div>
            </div>
            <div>
              <div>快递：</div>
              <div>
                {courier_list.map((item, idx) => (
                  <span
                    key={idx}
                    className={`${
                      courier === item.courier ? "home_new_box_active" : ""
                    } home_new_box_item`}
                    onClick={() =>
                      this.handleChangeItem("courier", item.courier)
                    }
                  >
                    {item.courier}
                  </span>
                ))}
              </div>
            </div>
            {/* <div>
              <div>平台：</div>
              <div>
                {platform_list.map((item, idx) => (
                  <span
                    key={idx}
                    className={`${
                      platform === item.plat ? "home_new_box_active" : ""
                    } home_new_box_item`}
                    onClick={() => this.handleChangeItem("platform", item.plat)}
                  >
                    {item.plat}
                  </span>
                ))}
              </div>
            </div>
            <div>
              <div>超时赔付：</div>
              <div>
                {overtimePaid_list.map((item, idx) => (
                  <span
                    key={idx}
                    className={`${
                      overtimePaid === item.overtimePaid
                        ? "home_new_box_active"
                        : ""
                    } home_new_box_item`}
                    onClick={() =>
                      this.handleChangeItem("overtimePaid", item.overtimePaid)
                    }
                  >
                    {item.overtimePaid}
                  </span>
                ))}
              </div>
            </div> */}
            <div>
              <div>排序筛选：</div>
              <div className="flex-start">
                <div
                  className={`home_sort flex-center ${
                    sortBy === "goods_fee" ? "home_sort_active" : ""
                  }`}
                  style={{marginLeft: '24px'}}
                  onClick={(_) => this.changeSort("goods_fee", "type1")}
                >
                  价格排序
                  {sortBy === "goods_fee" ? (
                    <IconFont
                      type={
                        type1 === 1 ? "icon-icon-test" : "icon-icon-test-copy"
                      }
                      style={{ fontSize: 20 }}
                    />
                  ) : (
                    <IconFont
                      type="icon-icon-test-copy-copy"
                      style={{ fontSize: 20 }}
                    />
                  )}
                </div>
                <div
                  className={`home_sort flex-center ${
                    sortBy === "weight" ? "home_sort_active" : ""
                  }`}
                  onClick={(_) => this.changeSort("weight", "type2")}
                >
                  重量排序
                  {sortBy === "weight" ? (
                    <IconFont
                      type={
                        type2 === 1 ? "icon-icon-test" : "icon-icon-test-copy"
                      }
                      style={{ fontSize: 20 }}
                    />
                  ) : (
                    <IconFont
                      type="icon-icon-test-copy-copy"
                      style={{ fontSize: 20 }}
                    />
                  )}
                </div>
                <div className="home_sort_other">
                  <Dropdown
                    overlay={this.renderMenuItem(
                      platform_list,
                      platform,
                      "platform",
                      "plat"
                    )}
                    trigger={["click"]}
                    placement="bottomCenter"
                    onVisibleChange={(e) =>
                      this.setState({ isPlatformRotate: e })
                    }
                    disabled={sortBy === "collect"}
                  >
                    <div>
                      {platform ? platform : "平台"}
                      <IconFont
                        type="icon-jiantou"
                        style={{
                          fontSize: 16,
                          marginLeft: 6,
                          transition: "transform 0.3s",
                          transform: isPlatformRotate ? "rotate(180deg)" : "",
                        }}
                      />
                    </div>
                  </Dropdown>
                </div>
                <div className="home_sort_other" style={{display: 'none'}}>
                  <Dropdown
                    overlay={this.renderMenuItem(
                      overtimePaid_list,
                      overtimePaid,
                      "overtimePaid",
                      "overtimePaid"
                    )}
                    trigger={["click"]}
                    placement="bottomCenter"
                    onVisibleChange={(e) =>
                      this.setState({ isOvertimeRotate: e })
                    }
                    disabled={sortBy === "collect"}
                  >
                    <div>
                      {overtimePaid ? overtimePaid : "是否支持超时赔付"}
                      <IconFont
                        type="icon-jiantou"
                        style={{
                          fontSize: 16,
                          marginLeft: 6,
                          transition: "transform 0.3s",
                          transform: isOvertimeRotate ? "rotate(180deg)" : "",
                        }}
                      />
                    </div>
                  </Dropdown>
                </div>
              </div>
              {/*<div className="home_search_icon_wrapper"*/}
              {/*     style={{textAlign: "right"}}>*/}
              {/*  {isLine && (<IconFont*/}
              {/*    type="icon-liebiao"*/}
              {/*    style={{*/}
              {/*      fontSize: 16,*/}
              {/*      transition: "transform 0.3s",*/}
              {/*    }}*/}
              {/*    onClick={() => {*/}
              {/*      this.setState({isLine: !isLine})*/}
              {/*    }}/>)}*/}
              {/*  {!isLine && (<IconFont*/}
              {/*    type="icon-kapian"*/}
              {/*    style={{*/}
              {/*      fontSize: 16,*/}
              {/*      transition: "transform 0.3s",*/}
              {/*    }}*/}
              {/*    onClick={() => {*/}
              {/*      this.setState({isLine: !isLine})*/}
              {/*    }}/>)}*/}
              {/*</div>*/}
            </div>
            <div
              style={{
                width: 1200,
                height: 10,
                background: "#f5f5f5",
                margin: "0 auto",
              }}
            ></div>
          </div>
        </Affix>
        <InfiniteScroll
          initialLoad={false}
          loadMore={this.handleMoreGoodList}
          hasMore={!loading && hasMore}
          threshold={100}>
          {!isLine && (<div
            style={{
              width: 1200,
              margin: "0 auto",
            }}
          >
            {goods_list.map((item, idx) => (
              <div
                key={item.goodsId}
                className="new_home_goods flex-start"
                style={{ marginTop: idx * 1 === 0 ? 0 : 10 }}
              >
                <div style={{ position: "relative" }}>
                  <img
                    src={
                      item.productPhoto1
                        ? `${item.productPhoto1}`
                        : `${imgRoot}/photo.png`
                    }
                    alt=""
                  />
                  <div className="new_home_goods_icon">产品实拍</div>
                </div>
                <div style={{ position: "relative" }}>
                  <img
                    src={
                      item.productPhoto2
                        ? `${item.productPhoto2}`
                        : `${imgRoot}/photo.png`
                    }
                    alt=""
                  />
                  <div className="new_home_goods_icon">产品实拍</div>
                </div>
                <div style={{ position: "relative" }}>
                  <img
                    src={
                      item.packagePhoto
                        ? `${item.packagePhoto}`
                        : `${imgRoot}/photo.png`
                    }
                    alt=""
                  />
                  <div className="new_home_goods_icon">包裹实拍</div>
                </div>
                <div style={{ position: "relative" }}>
                  <img
                    src={
                      item.warehousePhoto
                        ? `${item.warehousePhoto}`
                        : `${imgRoot}/photo.png`
                    }
                    alt=""
                  />
                  <div className="new_home_goods_icon">供应商认证</div>
                </div>
                <div style={{ position: "relative" }}>
                  <img
                    src={
                      item.goodsImg
                        ? `${item.goodsImg}`
                        : `${imgRoot}/photo.png`
                    }
                    alt=""
                    style={{ marginRight: 30 }}
                  />
                  <div
                    className="new_home_goods_icon"
                    style={{ background: "rgba(51,170,255,1)" }}
                  >
                    主图
                  </div>
                </div>
                <div className="new_home_goods_info flex-column-between">
                  <div
                    style={{ display: "flex", justifyContent: "flex-start" }}
                  >
                    <div className="new_home_goods_title">{item.goodsName}</div>
                    <Tooltip
                      placement="top"
                      title={item.isCollect * 1 ? "取消收藏" : "收藏商品"}
                    >
                      <IconFont
                        type={`${
                          item.isCollect * 1 === 0
                            ? "icon-xiaotianshoucang"
                            : "icon-xiaotianshoucang2"
                          }`}
                        style={{ fontSize: 24, marginTop: 2, marginLeft: 6 }}
                        onClick={(e) =>
                          this.handleCollect(
                            item.goodsId,
                            item.isCollect * 1,
                            isLogin * 1,
                            idx,
                            e
                          )
                        }
                      />
                    </Tooltip>
                  </div>
                  <div>
                    <div className="flex-start">
                      <div
                        style={{
                          color: "#FF3333",
                          fontSize: 14,
                          marginRight: 6,
                        }}
                      >
                        ￥
                        <span
                          style={{
                            fontSize: 24,
                            fontWeight: 600,
                          }}
                        >
                          {(item.goodsFee / 100).toFixed(2)}
                        </span>
                      </div>
                      {/* <div className="home_baoyou">包邮</div> */}
                      {item.overtimePaid * 1 === 1 && (
                        <Tooltip
                          placement="top"
                          title={
                            <span>
                              1、出单超时赔付
                              <br />
                              该商品已加入出单超时赔付计划，最迟在完成付款时间的基础上延迟2小时完成打单发货。（例如：10:00付款的订单，必须在12:00前完成打单发货）如果超时，我们将给您赔付补偿。
                              <br />
                              2、揽收超时赔付
                              <br />
                              该商品已加入揽收超时赔付计划，当天18:00点前完成付款的包裹，需在第二天12:00前产生揽收记录，如果超时，我们将给您赔付补偿
                              <br />
                              当天18:00点后完成付款的包裹，需在第二天24:00前产生揽收记录，如果超时，我们将给您赔付补偿。
                              <br />
                              3、赔付金额
                              <br />
                              低于2元的商品，我们将按商品实际包邮价格，全额赔付；高于2元的商品，我们将全部按照2元赔付。
                            </span>
                          }
                        >
                          <img
                            src={`${imgRoot}/chaoshi.svg`}
                            alt=""
                            style={{
                              display: "block",
                              width: 76,
                              height: 22,
                              cursor: "pointer",
                            }}
                          />
                        </Tooltip>
                      )}
                    </div>
                    <div style={{ color: "#7A8399", marginBottom: 10 }}>
                      {item.weight}g/件
                    </div>
                    {canUse == 2 ? '' : (
                      <Button
                        type="primary"
                        style={{
                          width: "100%",
                          height: 24,
                          fontSize: 12,
                          padding: 0,
                          marginBottom: 10,
                        }}
                        onClick={(_) => this.handlePay(item)}
                      >
                        立即购买
                      </Button>
                    )}
                    <div className="flex-space">
                      <div className="new_home_goods_local">{item.address}</div>
                      <div className="new_home_goods_local flex-center">
                        <img src={item.courierImg} alt="" width="56px" />
                      </div>
                      <div className="new_home_goods_local">包邮</div>
                      {/* <div
                        className="new_home_goods_local"
                        style={{ borderColor: "#ff3333", color: "#ff3333" }}
                      >
                        立即购买
                      </div> */}
                    </div>
                  </div>
                  {/* <Tooltip
                    placement="top"
                    title={item.isCollect * 1 ? "取消收藏" : "收藏商品"}
                  >
                    <div
                      className="home_collect flex-center"
                      onClick={(e) =>
                        this.handleCollect(
                          item.goodsId,
                          item.isCollect * 1,
                          isLogin * 1,
                          idx,
                          e
                        )
                      }
                      style={{
                        width: item.isCollect * 1 === 1 ? 66 : 30,
                      }}
                    >
                      <IconFont
                        type="icon-shoucang1"
                        style={{ fontSize: 18 }}
                      />
                      {isLogin * 1 === 1 &&
                        item.isCollect * 1 === 1 &&
                        "已收藏"}
                    </div>
                  </Tooltip> */}
                </div>
              </div>
            ))}
          </div>)}

          {isLine && (<div
            style={{
              width: 1200,
              margin: "0 auto",
              display: "flex",
              flexWrap: "wrap",
            }}>
            {/*{goods_list.length && (<div*/}
            {/*  key="jimeimadou"*/}
            {/*  className="new_home_goods_flex"*/}
            {/*  style={{ marginRight: 12}}*/}
            {/*  onClick={() => {*/}
            {/*    if (window._hmt) {*/}
            {/*      window._hmt.push(['_trackEvent', 'home', 'link', 'jmmd'])*/}
            {/*    }*/}
            {/*    window.open("https://www.jimeimadou.com/#/?fr=xtdf");*/}
            {/*  }*/}
            {/*  }>*/}
            {/*  <img*/}
            {/*    style={{width: 230, height: 400, cursor: 'pointer'}}*/}
            {/*    src="https://img.jimeimadou.com/common/images/df_banner.png"/>*/}
            {/*</div>)}*/}
            {goods_list.map((item, idx) => (
              <div
                key={item.goodsId}
                style={{ marginRight: idx === 4 ? 0 : (idx % 5 === 4 ? 0 : 12) }}
                className="new_home_goods_flex">
                <div style={{ position: "relative", cursor: 'pointer' }}
                     onClick={(_) => this.handlePay(item)}>
                  {goodsId !== item.goodsId && (<div>
                    <img
                      src={
                        item.goodsImg
                          ? `${item.goodsImg}?imageMogr2/crop/230x230/gravity/center`
                          : `${imgRoot}/photo.png`
                      }
                      alt=""
                    />
                  </div>)}
                  {imgType === 'pro1' && goodsId === item.goodsId  && (
                    <div style={{position: "relative"}}>
                      <img
                        src={
                          item.productPhoto1
                            ? `${item.productPhoto1}?imageMogr2/crop/230x230/gravity/center`
                            : `${imgRoot}/photo.png`
                        }
                        alt=""
                      />
                      <div className="new_home_goods_icon">产品实拍</div>
                    </div>)}
                  {imgType === 'pro2' && goodsId === item.goodsId && (
                    <div style={{position: "relative"}}>
                      <img
                        src={
                          item.productPhoto2
                            ? `${item.productPhoto2}?imageMogr2/crop/230x230/gravity/center`
                            : `${imgRoot}/photo.png`
                        }
                        alt=""
                      />
                      <div className="new_home_goods_icon">产品实拍</div>
                    </div>)}
                  {imgType === 'package' && goodsId === item.goodsId && (
                    <div style={{position: "relative"}}>
                      <img
                        src={
                          item.packagePhoto
                            ? `${item.packagePhoto}?imageMogr2/crop/230x230/gravity/center`
                            : `${imgRoot}/photo.png`
                        }
                        alt=""
                      />
                      <div className="new_home_goods_icon">包裹实拍</div>
                    </div>)}
                  {imgType === 'warehouse' && goodsId === item.goodsId && (
                    <div style={{position: "relative"}}>
                      <img
                        src={
                          item.warehousePhoto
                            ? `${item.warehousePhoto}`
                            : `${imgRoot}/photo.png`
                        }
                        alt=""
                      />
                      <div className="new_home_goods_icon">供应商认证</div>
                    </div>)}
                </div>
                <div className="new_home_goods_info_flex">
                  <div
                    className="new_home_goods_title_wrapper flex-space">
                    <div
                      className="new_home_goods_title_flex"
                      title={item.goodsName}>
                      {item.goodsName}
                    </div>
                    <div className="icon">
                      <Tooltip
                        placement="top"
                        title={item.isCollect * 1 ? "取消收藏" : "收藏商品"}>
                        <IconFont
                          type={`${
                            item.isCollect * 1 === 0
                              ? "icon-xiaotianshoucang"
                              : "icon-xiaotianshoucang2"
                            }`}
                          style={{fontSize: 24, marginTop: 2, marginLeft: 6}}
                          onClick={(e) =>
                            this.handleCollect(
                              item.goodsId,
                              item.isCollect * 1,
                              isLogin * 1,
                              idx,
                              e
                            )}/>
                      </Tooltip>
                    </div>
                  </div>
                  <div>
                    <div className="new_home_goods_price_flex flex-space">
                      <div style={{color: "#FF3333"}}>
                        <span style={{fontSize: 14, marginRight: 2}}>￥</span>
                        <span style={{fontSize: 20, fontWeight: 600}}>
                          {(item.goodsFee / 100).toFixed(2)}
                        </span>
                        <span className="new_home_goods_local_flex" style={{marginLeft: 4}}>包邮</span>
                        {item.overtimePaid * 1 === 1 && (
                          <Tooltip
                            placement="top"
                            title={
                              <span>
                              1、出单超时赔付
                              <br/>
                              该商品已加入出单超时赔付计划，最迟在完成付款时间的基础上延迟2小时完成打单发货。（例如：10:00付款的订单，必须在12:00前完成打单发货）如果超时，我们将给您赔付补偿。
                              <br/>
                              2、揽收超时赔付
                              <br/>
                              该商品已加入揽收超时赔付计划，当天18:00点前完成付款的包裹，需在第二天12:00前产生揽收记录，如果超时，我们将给您赔付补偿
                              <br/>
                              当天18:00点后完成付款的包裹，需在第二天24:00前产生揽收记录，如果超时，我们将给您赔付补偿。
                              <br/>
                              3、赔付金额
                              <br/>
                              低于2元的商品，我们将按商品实际包邮价格，全额赔付；高于2元的商品，我们将全部按照2元赔付。
                            </span>
                            }>
                            <img
                              src={`${imgRoot}/chaoshi.svg`}
                              alt=""
                              style={{
                                display: "inline-block",
                                width: 61,
                                height: 22,
                                cursor: "pointer",
                                marginBottom: 1,
                                marginLeft: 1,
                              }}
                            />
                          </Tooltip>
                        )}
                      </div>
                      <div style={{color: "#7A8399"}}>
                        {item.weight}g/件
                      </div>
                    </div>
                  </div>

                  <div className="flex-space" style={{marginTop: 8,}}>
                    <div className="new_home_goods_local">{item.address}</div>
                    <div className="new_home_goods_local flex-center">
                      <img src={item.courierImg} alt="" width="56px"/>
                    </div>
                    {canUse == 2 ? '' : (
                      <Button
                        type="primary"
                        style={{
                          width: 80,
                          height: 24,
                          fontSize: 12,
                          padding: 0
                        }}
                        onClick={() => this.handlePay(item)}>
                        立即购买
                      </Button>
                    )}
                  </div>
                  <div className="img_wrapper flex-space-colstart" style={{marginTop: '10px'}}>
                    <img
                      style={{width: '48px',height:'48px',borderRadius: '4px',objectFit: 'cover', cursor: 'pointer'}}
                      src={
                        item.productPhoto1
                          ? `${item.productPhoto1}?imageMogr2/crop/48x48/gravity/center`
                          : `${imgRoot}/photo.png`
                      }
                      alt=""
                      onMouseEnter={()=>{this.setState({imgType: 'pro1', goodsId: item.goodsId})}}
                      onMouseLeave={()=>{this.setState({imgType: 'main', goodsId: ''})}}
                    />
                    <img
                      style={{width: '48px',height:'48px',borderRadius: '4px',objectFit: 'cover', cursor: 'pointer'}}
                      src={
                        item.productPhoto2
                          ? `${item.productPhoto2}?imageMogr2/crop/48x48/gravity/center`
                          : `${imgRoot}/photo.png`
                      }
                      alt=""
                      onMouseEnter={()=>{this.setState({imgType: 'pro2', goodsId: item.goodsId})}}
                      onMouseLeave={()=>{this.setState({imgType: 'main', goodsId: ''})}}
                    />
                    <img
                      style={{width: '48px',height:'48px',borderRadius: '4px',objectFit: 'cover', cursor: 'pointer'}}
                      src={
                        item.packagePhoto
                          ? `${item.packagePhoto}?imageMogr2/crop/48x48/gravity/center`
                          : `${imgRoot}/photo.png`
                      }
                      alt=""
                      onMouseEnter={()=>{this.setState({imgType: 'package', goodsId: item.goodsId})}}
                      onMouseLeave={()=>{this.setState({imgType: 'main', goodsId: ''})}}
                    />
                    <img
                      style={{width: '48px',height:'48px',borderRadius: '4px',objectFit: 'cover', cursor: 'pointer'}}
                      src={"https://dfcdn.waxiang.com/source/daifa/authImage.png"}
                      alt=""
                      onMouseEnter={()=>{this.setState({imgType: 'warehouse', goodsId: item.goodsId})}}
                      onMouseLeave={()=>{this.setState({imgType: 'main', goodsId: ''})}}
                    />
                  </div>
                </div>
                </div>
            ))}
          </div>)}

          {/* <div
            className="flex-start"
            style={{
              flexWrap: "wrap",
              width: 1200,
              minHeight: 200,
              margin: "0 auto",
            }}
          >
            {goods_list.map((item, idx) => (
              <div
                key={item.goodsId}
                className="home_goods"
                style={{ marginRight: (idx + 1) % 5 === 0 ? 0 : 25 }}
                onMouseEnter={(_) => this.setState({ isShowBuy: item.goodsId })}
                onMouseLeave={(_) => this.setState({ isShowBuy: "" })}
                onClick={(_) => {
                  history.push(`/seller/goods/goodsinfo?${item.goodsId}`);
                }}
              >
                <div className="home_goods_img">
                  <img src={item.goodsImg} alt="" />
                </div>
                <div className="home_goods_info flex-column-between">
                  <div className="home_goods_title">{item.goodsName}</div>
                  <div className="flex-space">
                    <div className="flex-start">
                      <div
                        style={{
                          fontSize: 20,
                          fontWeight: 600,
                          color: "#ff3333",
                          marginRight: 10,
                        }}
                      >
                        ￥{(item.goodsFee / 100).toFixed(2)}
                      </div>
                      <div className="home_goods_baoyou">包邮</div>
                    </div>
                    <div style={{ fontSize: 12, color: "#666666" }}>
                      {item.weight}g/件
                    </div>
                  </div>
                  <div className="flex-space">
                    <div className="home_goods_local">{item.address}</div>
                    <div className="home_goods_local">{item.courier}</div>
                  </div>
                </div>
                <div
                  className="home_goods_hover"
                  style={{
                    display: isShowBuy === item.goodsId ? "block" : "none",
                    // display: "block",
                  }}
                >
                  <div className="flex-start home_goods_hover_info">
                      <div className="home_goods_hover_title">发货详情</div>
                      <div className="home_goods_hover_line"></div>
                      <div
                        className="home_goods_hover_detail flex-column-between"
                        style={{ height: 118 }}
                      >
                        <div>出单截止时间：23:59:59</div>
                        <div>发货截止时间：23:59</div>
                        <div>仓储：义乌</div>
                        <div>快递：韵达</div>
                        <div>不发：新疆、西藏</div>
                      </div>
                    </div>
                    <div className="flex-start home_goods_hover_info">
                      <div className="home_goods_hover_title">物流时效</div>
                      <div className="home_goods_hover_line"></div>
                      <div
                        className="home_goods_hover_detail flex-column-between"
                        style={{ height: 118 }}
                      >
                        <div>
                          平均出单时间：8分钟
                          <Tooltip
                            placement="top"
                            title="平均出单时间：近三天，在9:00至18:00时间段，下单到出单号的平均时长=【（A包裹下单时间-A包裹出单时间）+（B包裹下单时间-B包裹出单时间）+（C包裹下单时间-C包裹出单时间）】/ (A+B+C)单量"
                          >
                            <IconFont
                              type="icon-bangzhu"
                              style={{
                                fontSize: 14,
                                color: "#333333",
                                marginLeft: 2,
                              }}
                            />
                          </Tooltip>
                        </div>
                        <div>
                          平均揽收时间：6小时
                          <Tooltip
                            placement="top"
                            title="平均揽收时间：近三天，在9:00至18:00时间段，下单到出单号的平均时长=【（A包裹下单时间-A包裹揽收时间）+（B包裹下单时间-B包裹揽收时间）+（C包裹下单时间-C包裹揽收时间）】/ (A+B+C)单量"
                          >
                            <IconFont
                              type="icon-bangzhu"
                              style={{
                                fontSize: 14,
                                color: "#333333",
                                marginLeft: 2,
                              }}
                            />
                          </Tooltip>
                        </div>
                        <div>
                          24小时揽收率：70%
                          <Tooltip
                            placement="top"
                            title="24小时揽收率：近三天，下单后，在24h内完成揽收的比例=【（包裹出单时间-包裹揽收时间）<24h】的单量/总单量"
                          >
                            <IconFont
                              type="icon-bangzhu"
                              style={{
                                fontSize: 14,
                                color: "#333333",
                                marginLeft: 2,
                              }}
                            />
                          </Tooltip>
                        </div>
                        <div>
                          中转超时率：5%
                          <Tooltip
                            placement="top"
                            title="中转超时率：近三天，物流中转停留超过48小时的比例= 【已揽收包裹（物流信息最后一次更新时间 - 当下时间）>48h 的单量】/已揽收包裹总单量 "
                          >
                            <IconFont
                              type="icon-bangzhu"
                              style={{
                                fontSize: 14,
                                color: "#333333",
                                marginLeft: 2,
                              }}
                            />
                          </Tooltip>
                        </div>
                      </div>
                    </div>
                    <div className="home_goods_title">{item.goodsName}</div>
                    <div className="flex-space">
                      <div className="flex-start">
                        <div
                          style={{
                            fontSize: 20,
                            fontWeight: 600,
                            color: "#ff3333",
                            marginRight: 10,
                          }}
                        >
                          ￥{(item.goodsFee / 100).toFixed(2)}
                        </div>
                        <div className="home_goods_baoyou">包邮</div>
                      </div>
                      <div style={{ fontSize: 12, color: "#666666" }}>
                        {item.weight}g/件
                      </div>
                    </div>
                  <div className="home_goods_buy">立即购买</div>
                </div>
              </div>
            ))}
          </div> */}
          {loading && (
            <div style={{ textAlign: "center", margin: 20 }}>
              <Spin size="large" tip="努力加载中" />
            </div>
          )}
        </InfiniteScroll>
        <div
          style={{
            fontSize: 14,
            color: "#999999",
            textAlign: "center",
            margin: 24,
          }}
        >
          {hasMore ? "下拉加载更多" : "暂无更多商品"}
        </div>
        <Modal
          visible={isShowModal}
          footer={null}
          onCancel={(_) => this.setState({ isShowModal: false })}
          className="modal_paid"
        >
          <div>
            <div className="modal_paid_title">
              <div style={{ fontSize: 26, color: "#33AAFF" }}>
                为迎合各平台发货规则，提升礼品服务水平，特推出超时赔付计划
              </div>
              <div className="flex-center" style={{ marginTop: 18 }}>
                有
                <img
                  src={`${imgRoot}/chaoshi.svg`}
                  alt=""
                  style={{ margin: "0 10px" }}
                />
                标识即表示该商品已加入超时赔付计划
              </div>
            </div>
            <div className="modal_paid_box">
              <div>具体赔付规则如下：</div>
              <div className="modal_paid_content">
                <div style={{ color: "#1a2133", fontWeight: 600 }}>
                  出单超时赔付
                </div>
                <div className="flex-start">
                  <div className="modal_paid_text">
                    付款后的订单最迟会在2小时内完成发货并返回快递单号
                  </div>
                  <div className="modal_paid_text" style={{ marginLeft: 40 }}>
                    例如：10点付款的订单，所有包裹必须在12点前完成发货
                  </div>
                </div>
                <div className="modal_paid_text">
                  如果超时，平台将自动给您赔付补偿
                </div>
              </div>
              <div className="modal_paid_content">
                <div style={{ color: "#1a2133", fontWeight: 600 }}>
                  揽收超时赔付
                </div>
                <div className="flex-start">
                  <div className="modal_paid_text">
                    当天18点前完成付款的包裹，需在第二天12点前产生揽收记录
                  </div>
                  <div className="modal_paid_text" style={{ marginLeft: 40 }}>
                    当天18点后完成付款的包裹，需在第二天24点前产生揽收记录
                  </div>
                </div>
                <div className="modal_paid_text">
                  如果超时，平台将自动给您赔付补偿
                </div>
              </div>
              <div className="modal_paid_content" style={{ height: 133 }}>
                <div style={{ color: "#1a2133", fontWeight: 600 }}>
                  如果觉得小天礼品靠谱好用，可以将我们分享给身边的电商朋友，邀请好友下单还可以领取现金奖励
                </div>
                <div className="flex-start" style={{ marginTop: 24 }}>
                  <div
                    style={{ width: 30, margin: "0 16px", color: "#1a2133" }}
                  >
                    邀请方式
                  </div>
                  <div>
                    <div style={{ marginBottom: 10 }}>
                      登录—个人中心—推广赚钱—复制推广链接—发到商家群/好友
                    </div>
                    <div>
                      通过您的邀请链接注册的商家用户，支付的每一单包裹，您都可以得到现金奖励！
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </Modal>
        <Modal
          width={350}
          visible={isShowAuth}
          onOk={this.toAuth}
          okText="去实名"
          onCancel={(_) => this.setState({ isShowAuth: false })}>
          <div>
            <div>
              <div style={{ fontSize: 16}}>
                请先完成实名认证
              </div>
            </div>
          </div>
        </Modal>
      </div>
    );
  }
}
export default All;
